import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای مدیریت گروه‌های کاری (Rosters)

این صفحه ابزار اصلی شما برای تعریف الگوهای کاری (شیفت‌های ثابت و چرخشی) در سطح کارخانه است.

## ۱. ایجاد قالب شیفت جدید (Shift Template)
شیفت‌ها بلاک‌های پایه‌ای زمان کاری هستند که در این بخش تعریف می‌شوند. هر قالب می‌تواند یک شیفت عادی کاری، استراحت، یا اضافه‌کاری باشد.

- **کد و نام قالب:** برای شیفت خود یک کد (مثل SH-M) و یک نام (مثل شیفت صبح) تعیین کنید.
- **نوع شیفت (Category):** از بین مواردی چون «عادی»، «اضافه‌کاری»، «استراحت/تعطیلی» و «مرخصی» نوع آن را مشخص کنید.
- **ساعت شروع و پایان:** ساعت دقیق ورود و خروج را مشخص کنید.

> **نکته مهم:** برای روزهای تعطیل در چرخه‌های کاری حتماً یک قالب شیفت از نوع `استراحت/تعطیلی` ایجاد کنید تا بتوانید آن را به روزهای تعطیل Roster اختصاص دهید.

## ۲. ایجاد گروه کاری (Roster)
یک Roster نماینده‌ی یک الگوی تکرارشونده است (مثلاً چرخه ۱۴ روزه).

- **کد و نام Roster:** یک شناسه و نام برای الگو وارد کنید (مثلاً چرخه شیفت روز/شب).
- **طول دوره (Days):** تعداد روزهایی که پس از آن این الگو تکرار می‌شود را وارد نمایید. اگر یک شیفت ثابت هفتگی است، طول آن را ۷ روز قرار دهید.

## ۳. تخصیص روزها (Roster Days)
پس از ساخت Roster و قالب‌های شیفت، باید تعیین کنید در هر روز از طول دوره‌ی این Roster چه اتفاقی می‌افتد.

- ابتدا از لیست Roster ها، مورد دلخواه را انتخاب کنید.
- سپس شماره روز (مثلاً روز اول تا روز هفتم) و قالب شیفت متناظر با آن روز را وارد و دکمه **«افزودن شیفت به این روز»** را بزنید.
- می‌توانید در جدول پایین صفحه ساختار کامل و ترتیب شیفت‌ها در آن چرخه را مشاهده کنید.

با تخصیص اپراتورها به این Rosterها (در بخش [تخصیص اپراتورها](/production/shopfloor/roster-assignments))، سیستم به صورت خودکار محاسبه می‌کند که هر شخص در هر تاریخ تقویمی در کدام شیفت باید حضور داشته باشد.


export default Layout;
